<template>
  <div class="two-container">
    <!-- <div class="little-title">{{$theme ? "加入我们" : "JOIN US"}}</div> -->
    <div class="little-title2">
      <div>{{$theme ? "加入我们" : "JOIN US"}}</div>
    </div>
    <vue-seamless-scroll
      :data="joinUsList"
      class="tjwt-pie-right"
      :classOption="{
        step: 2,
        autoPlay: true,
        limitMoveNum: 5,
        direction: 2,
        hoverStop: false,
      }"
    >
      <div class="con">
        <div
          class="one-img"
          v-for="(item, ind) in joinUsList"
          :key="ind + 'sx'"
        >
          <img :src="item.img" alt="" />
          <!-- <span>{{ $theme ?  item.name : item.nameEng }}</span> -->
        </div>
      </div>
    </vue-seamless-scroll>
    <!-- <div class="text-1">{{$theme ? "加入我们" : "JOIN US"}}</div> -->
    <div class="text-2">{{$theme ? "独木难支大厦，众志可成城郭" : ""}}</div>
    <div class="text-3">The power of unity is unstoppable</div>
  </div>
</template>

<script>
import VueSeamlessScroll from "vue-seamless-scroll";
export default {
  data() {
    return {
      joinUsList: [
        {
          name: "园区",
          nameEng: "Park",
          img: require("/static/image/home/join-us-1.png"),
        },
        {
          name: "办公区",
          nameEng: "Office Area",
          img: require("/static/image/home/join-us-2.png"),
        },
        {
          name: "休闲区",
          nameEng: "Recreation Area",
          img: require("/static/image/home/join-us-3.png"),
        },
        {
          name: "健身区",
          nameEng: "Fitness Area",
          img: require("/static/image/home/join-us-4.png"),
        },
        {
          name: "会议区",
          nameEng: "Meeting Area",
          img: require("/static/image/home/join-us-5.png"),
        },
        {
          name: "餐饮区",
          img: require("/static/image/home/join-us-6.png"),
        },
        {
          name: "团建照片",
          nameEng: "Team building photos",
          img: require("/static/image/home/join-us-7.png"),
        },
        {
          name: "团建照片",
          img: require("/static/image/home/join-us-8.png"),
        },
        {
          name: "团建照片",
          img: require("/static/image/home/join-us-9.png"),
        },
        {
          name: "团建照片",
          img: require("/static/image/home/join-us-10.png"),
        },
        {
          name: "团建照片",
          nameEng: "Team building photos",
          img: require("/static/image/home/join-us-11.png"),
        },
        {
          name: "团建照片",
          img: require("/static/image/home/join-us-12.png"),
        },
        // {
        //   name: "汉熵精英",
        //   nameEng: "ChinaEntropy Elite",
        //   img: require("/static/image/home/joinus-13.png"),
        // },
      ],
    };
  },
  props: {},
  components: {
    VueSeamlessScroll
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {},
  watch: {},
};
</script>

<style scoped lang="scss">
@import "./Index.scss";
</style>
